import { Link } from "react-router-dom";
import { Section, Eyebrow } from "@/components/Primitives";

export default function NotFound() {
  return (
    <Section className="pt-24 pb-24 text-center">
      <Eyebrow>Page not found</Eyebrow>
      <h1 className="font-serif-display text-5xl text-stone-900 mt-4">We can't find that page</h1>
      <p className="text-stone-600 mt-4 max-w-md mx-auto">
        The page you're looking for may have moved. Let's get you back to a calm starting point.
      </p>
      <div className="flex flex-wrap gap-4 justify-center mt-8">
        <Link to="/" data-testid="notfound-home-cta" className="btn-terracotta rounded-full px-6 py-3.5 text-sm font-semibold">
          Back to home
        </Link>
        <Link to="/assessments" data-testid="notfound-assessments-cta" className="rounded-full px-6 py-3.5 text-sm font-semibold border border-stone-300 text-stone-700 hover:bg-white">
          Browse assessments
        </Link>
      </div>
    </Section>
  );
}
